<template>
  <div class="scroll-container pointer" :class="[visible ? 'padding-y-15' : '']" ref="scrollBarRef">
    <div class="yd-scroll-bar" v-if="visible" :style="{ width: tableWidth + 'px', height: '8px' }">
      <div class="bar"></div>
    </div>
  </div>
  <!-- <YdScrollBar>
      <div
        ref="scrollBarRef"
        class="full-x"
        :class="[visible ? 'padding-y-10' : '']"
        style="overflow-x: scroll"
      >
        <div :style="{ width: tableWidth + 'px', height: '8px' }"></div>
      </div>
    </YdScrollBar> -->
</template>
<script >
import { watch, ref, shallowRef, onMounted, onBeforeUnmount, nextTick } from '@vue/composition-api';
import { useOnScroll } from '../../hooks';
import { on, off } from '@/util';
import { throttle } from 'lodash-es';
const __sfc_main = {};
__sfc_main.props = {
  scrollLeft: {
    type: Number,
    default: 0
  },
  setScrollLeft: {
    type: Function,
    default: () => {}
  },
  tableWidth: {
    type: Number,
    default: 0
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const scrollBarRef = shallowRef(null);
  const visible = ref(false);
  const {
    scrollLeft: x
  } = useOnScroll(scrollBarRef);
  watch(x, v => {
    props.setScrollLeft(v);
  });
  watch(() => props.scrollLeft, left => {
    if (scrollBarRef.value) {
      scrollBarRef.value.scroll({
        top: 0,
        left: left || 0,
        behavior: 'smooth'
      });
    }
  });
  const calcWidth = () => {
    if (scrollBarRef.value) {
      const w = scrollBarRef.value.getBoundingClientRect().width || 0;
      visible.value = props.tableWidth > w;
    }
  };
  onMounted(() => {
    nextTick(() => {
      const time = setTimeout(() => {
        clearTimeout(time);
        calcWidth();
      }, 1200);
    });
    on(window, 'resize', throttle(calcWidth, 500));
  });
  onBeforeUnmount(() => {
    off(window, 'resize', throttle(calcWidth, 500));
  });
  return {
    scrollBarRef,
    visible
  };
};
export default __sfc_main;
</script>
<style scoped lang="scss">
  .scroll-container {
    overflow-y: hidden;
    overflow-x: scroll;
    height: 0;
  }
</style>
